import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 查询所有用户身份
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-member/category/getCategoryList`, params),
    //修改用户身份
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/category/updateCategory`, params),
    //新增用户身份
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/category/saveCategory`, params),
    //删除用户身份
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/category/deleteCategory`, params),
}